import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AnnualReportingData} from '../../../../shared/types/nso-data-portal/dashboard-data';
import {
  OrganizationInformationRestService
} from '../../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';

@Component({
  selector: 'wsd-annual-reports-organization',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './annual-reports-organization.component.html',
  styleUrls: ['./annual-reports-organization.component.css']
})
export class AnnualReportsOrganizationComponent implements OnChanges {

  annualReporting$: Observable<AnnualReportingData>;

  @Input()
  organizationId: number;

  @Input()
  groupAdminView: boolean;

  constructor(private organizationService: OrganizationInformationRestService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.annualReporting$ =
      this.organizationService.getAnnualReporting(this.organizationId)
        .pipe(share());

  }
}
